import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useLanguage } from '../components/Layout/LanguageContext';

const ImprintSection = styled.section`
  min-height: 100vh;
  padding: 100px 2rem;
  background: var(--background);
`;

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const Title = styled(motion.h1)`
  font-size: clamp(36px, 6vw, 60px);
  margin-bottom: 2rem;
  text-align: center;
  color: #e6f1ff;
  font-weight: 600;
`;

const Content = styled(motion.div)`
  background: rgba(35, 53, 84, 0.5);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 105, 180, 0.1);
  border-radius: 16px;
  padding: 2rem;

  h2 {
    color: var(--primary);
    font-size: 1.8rem;
    margin: 2rem 0 1rem;

    &:first-child {
      margin-top: 0;
    }
  }

  p {
    color: var(--text-secondary);
    margin-bottom: 1rem;
    line-height: 1.6;
  }

  strong {
    color: var(--text-primary);
    font-weight: 600;
  }

  a {
    color: var(--primary);
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

const imprintContent = {
  de: {
    title: 'Impressum',
    content: `
      <h1>Impressum</h1>

      <p>Yannick Reinke<br />
      IT Beratung<br />
      Arnikaweg 2<br />
      87527 Sonthofen</p>

      <h2>Kontakt</h2>
      <p>Telefon: +491604296531<br />
      E-Mail: kontakt@it-beratung-reinke.de</p>

      <h2>Angaben zur Berufs&shy;haftpflicht&shy;versicherung</h2>
      <p><strong>Name und Sitz des Versicherers:</strong><br />
      exali AG - Das Versicherungsportal f&uuml;r Dienstleister und freie Berufe<br />
      Franz-Kobinger-Str. 9<br />
      86157 Augsburg</p>
      <p><strong>Geltungsraum der Versicherung:</strong><br />Weltweit</p>

      <h2>Verbraucher&shy;streit&shy;beilegung/Universal&shy;schlichtungs&shy;stelle</h2>
      <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>

      <p>Quelle: <a href="https://www.e-recht24.de">e-recht24.de</a></p>
    `,
  },
  en: {
    title: 'Imprint',
    content: `
      <h1>Imprint</h1>

      <p>Yannick Reinke<br />
      IT Consulting<br />
      Arnikaweg 2<br />
      87527 Sonthofen</p>

      <h2>Contact</h2>
      <p>Phone: +491604296531<br />
      E-Mail: kontakt@it-beratung-reinke.de</p>

      <h2>Professional Liability Insurance</h2>
      <p><strong>Name and registered office of the insurer:</strong><br />
      exali AG - The insurance portal for service providers and freelancers<br />
      Franz-Kobinger-Str. 9<br />
      86157 Augsburg</p>
      <p><strong>Scope of insurance:</strong><br />Worldwide</p>

      <h2>Consumer Dispute Resolution/Universal Arbitration Board</h2>
      <p>We are not willing or obliged to participate in dispute resolution procedures before a consumer arbitration board.</p>

      <p>Source: <a href="https://www.e-recht24.de">e-recht24.de</a></p>
    `,
  },
};

const Imprint: React.FC = () => {
  const { language } = useLanguage();
  const t = imprintContent[language];
  return (
    <ImprintSection>
      <Container>
        <Title
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          {t.title}
        </Title>
        <Content
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          dangerouslySetInnerHTML={{ __html: t.content }}
        />
      </Container>
    </ImprintSection>
  );
};

export default Imprint; 